// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"120c33f1","158":"14552b47","219":"e3c86b4f","326":"abda0e82","493":"2cbaf6ce","798":"6e7c2c92","941":"7bc6266a","943":"8e06b201"}[chunkId] + ".chunk.js";
};